import jwtDecode from "jwt-decode";
import ToolbarMixin from "../ToolbarMixin";
import {
  showClickableSnackbar,
  showErrorNotification,
  showInfoNotification,
  showSuccessNotification,
  showWarningNotification,
} from "../components/common/NotiService";
import { app } from "../config";
import {
  addTransferNumber,
  clearTransferComments,
  setCallControlsActions,
  setCurrentLocationTimeAndRescheduleTime,
  setIVRcheckpointData,
  setScreenpopURL,
} from "../context/callSlice";
import { removeTab } from "../context/dashboardSlice";
import { handlePullChatsDialog, setEmailData } from "../context/digitalSlice";
import { store } from "../context/store";
import {
  handleDispositionEnable,
  handleMultiDisposition,
  loading,
  setAdminToken,
  setDispositionReqbody,
  setDispositionValues,
  setParkingChatsCount,
  setRefreshToken,
  setScreenRecordingByApp,
  setSkillTransfer,
  setWarmTransferdisableHoldButton,
} from "../context/toolbarSlice";
import { aToolbar } from "../toolbar";
import { endCurrentCall } from "./authService";
import HttpService from "./http.service";
import LocalStorageService from "./localstorage.service";
import Logger from "./logger.service";
import { constructURL, getAgentData, getParam, getBrowserSessionId, getUserId, 
  handleScreenRecording, isMaskNumberEnabled, isMobileDevice, preLogin, 
  removeScreenpopFromStorage, clearSession, playMsgAlert, closeAllPreviewScreenpops, 
  getRoleStatus, isUcidRecordingMode, closePreviewScreenpop, updateScreenRecordingUcid
} from "./util";
import {
  appendNewObjWithCallData,
  handleScreenPopClose,
  pauseAgent,
  releaseAgent,
} from "./webEventHandlers";
import { log } from "loglevel";
import JSEncrypt from "jsencrypt";
import WSocketService from "./websocket.service";

var reqCounter = 0;

// using for websocket heart beat send payload
export function useReqCounter() {
  return ++reqCounter;
}
const REQUEST_MAPPER = {
  tbAgentLogin: {
    params: "INBOUND",
    reconnect: "false",
    agentId: null,
    agentUniqId: null,
    customer: null,
    phoneNumber: null,
  },
  tbAgentLogout: {
    params: null,
    logoutBy: "logoffByAgent",
    agentId: null,
    agentUniqId: null,
    customer: null,
    phoneNumber: null,
  },
  tbAgentPause: {
    params: null,
    agentId: null,
    agentUniqId: null,
    source: "toolbar",
    customer: null,
  },
  tbAgentRelease: {
    params: null,
    mes: null,
    agentId: null,
    agentUniqId: null,
    customer: null,
    campId: null,
    ucid: null,
    monitorUcid: null,
    source: "toolbar"
  },
  tbGetQueueCount: {
    agentId: null,
    agentUniqId: null,
    customer: null,
  },
  tbReconnect: {
    reconnect: "true",
    mode: null,
    agentId: null,
    agentUniqId: null,
    customer: null,
    phoneNumber: null,
    event: null,
    ucid: null,
  },

  tbKickCall: {
    agentId: null,
    agentUniqId: null,
    customer: null,
    phoneNumberToKick: null,
    monitorUcid: null,
    ucid: null,
  },
  tbSkipPreviewNumber: {
    params: null,
    agentId: null,
    agentUniqId: null,
    customer: null,
  },
  tbResetPreviewNumber: {
    params: null,
    agentId: null,
    agentUniqId: null,
    customer: null,
  },
  tbFailCallback: {
    cbId: null,
    cbNumber: null,
    agentId: null,
    agentUniqId: null,
    customer: null,
  },
  tbRescheduleCallback: {
    cbId: null,
    cbNumber: null,
    rsComment: null,
    cbTime: null,
    callbacktz: null,
    agentId: null,
    agentUniqId: null,
    customer: null,
  },
  tbGetCallBackList: {
    agentId: null,
    agentUniqId: null,
    customer: null,
  },
  tbCallBackDial: {
    params: null,
    agentId: null,
    agentUniqId: null,
    customer: null,
    obdJava: false,
  },
  deleteCallback: {
    cbId: null,
    agentId: null,
    agentUniqId: null,
    customer: null,
  },
  initChatOnCall: {
    callerId: null,
    skill: null,
    did: null,
    monitorUcid: null,
    usId: null,
    agentId: null,
    agentUniqId: null,
    customer: null,
  },
  tbDropHold: {
    agentNumber: null,
    customerNumber: null,
    monitorUcid: null,
    ucid: null,
    did: null,
    agentId: null,
    agentUniqId: null,
    customer: null,
  },
  tbPauseAlert: {
    reason: null,
    to: null,
    agentId: null,
    agentUniqId: null,
    customer: null,
  },
  tbHold: {
    phoneNumberToHold: null,
    campignId: null,
    monitorUcid: null,
    ucid: null,
    did: null,
    agentId: null,
    agentUniqId: null,
    customer: null,
  },
  tbUnHold: {
    phoneNumberToUnHold: null,
    monitorUcid: null,
    ucid: null,
    did: null,
    agentId: null,
    agentUniqId: null,
    customer: null,
  },
  tbResetPwd: {
    curPwd: null,
    newPwd: null,
    agentId: null,
    agentUniqId: null,
    customer: null,
  },
  tbGetChatSkills: {
    //getChatTransferList
    did: null,
    agentId: null,
    agentUniqId: null,
    customer: null,
  },
  tbGetChatAgents: {
    //getChatTransferList
    did: null,
    agentId: null,
    agentUniqId: null,
    customer: null,
  },
  tbChatTransfer: {
    //setChatTransferFlag
    params: null,
    did: null,
    chatCustSessionId: null,
    apiKey: null,
    isDecline: null,
    agentId: null,
    agentUniqId: null,
    customer: null,
    campId: null,
  },
  checIfAgentIsChatting: {
    agentId: null,
    agentUniqId: null,
    customer: null,
  },
  fetchChatSession: {
    sessionId: null,
    agentId: null,
    agentUniqId: null,
    customer: null,
  },
  agentStartedTyping: {
    chatCustSessionId: null,
    agentId: null,
    agentUniqId: null,
    customer: null,
  },
  agentNoLongerTyping: {
    chatCustSessionId: null,
    agentId: null,
    agentUniqId: null,
    customer: null,
  },
  multiAgentChatMsg: {
    text: null,
    isFirstReply: null,
    chatCustSessionId: null,
    agentId: null,
    agentUniqId: null,
    customer: null,
  },
  agentMediaMsg: {
    url: null,
    mediaType: null,
    fileName: null,
    text: null,
    did: null,
    chatCustSessionId: null,
    clientId: null,
    apiKey: null,
    agentId: null,
    agentUniqId: null,
    customer: null,
  },
  disposeChat: {
    disp: null,
    comment: null,
    sessionId: null,
    monitorUcid: null,
    agentId: null,
    agentUniqId: null,
    customer: null,
  },

  tbAcceptChat: {
    did: null,
    chatCustSessionId: null,
    monitorUcid: null,
    apiKey: null,
    campaignId: null,
    custName: null,
    clientId: null,
    skillName: null,
    agentId: null,
    agentUniqId: null,
    customer: null,
  },

  tbConference: {
    confType: null, // 1 for agent 3 for phoneNumbers
    sip: null,
    participant: null,
    did: null,
    ucid: null,
    callerId: null,
    monitorUcid: null,
    agentId: null,
    agentUniqId: null,
    customer: null,
    transferId: null,
  },
  tbMergeUserToConference: {
    customer: null,
    agentId: null,
    ucid: null,
    monitorUcid: null,
    did: null,
    agentNumber: null,
    phoneNo: null
  },
  tbDropUserFromConference: {
    customer: null,
    agentId: null,
    ucid: null,
    monitorUcid: null,
    did: null,
    agentNumber: null,
    phoneNo: null
  },

  tbGetConferenceList: {
    confType: null,
    did: null,
    agentId: null,
    agentUniqId: null,
    customer: null,
  },

  tbGetCustomerData: {
    params: null,
    callType: null,
    monitorUcid: null,
    agentId: null,
    agentUniqId: null,
    customer: null,
  },

  tbGetTransferList: {
    transferType: null, //getNumberList -> transfer type is 3 for number list
    did: null,
    agentId: null,
    agentUniqId: null,
    customer: null,
    campId: null
  },

  tbSetTransfer: {
    params: null, // 3 phone 4 ivr // 2 skill // 1 agent // 1 for blind 3 for warm skill-skillUrl
    sip: null,
    monitorUcid: null,
    custNumber: null,
    campId: null,
    callType: null,
    agentName: null,
    skillName: null,
    agentId: null,
    agentUniqId: null,
    customer: null,
    crmInfo: null,
    uui: "",
    transferComments: "",
  },
  tbManualDial: {
    mode: null,
    params: null,
    isSip: null,
    playDisclaimer: null,
    agentId: null,
    agentUniqId: null,
    customer: null,
    redial: null,
    uui: "",
    obdJava: false,
    skillName: 0,
  },
  tbGetCampaigns: {
    agentId: null,
    customer: null,
  },
  tbGetManualCampaignSkills: {
    campaignId: null,
    agentId: null,
    agentUniqId: null,
    customer: null,
  },
  tbGetDispositions: {
    params: null,
    monitorUcid: null,
    agentId: null,
    agentUniqId: null,
    customer: null,
  },
  tbGetDispositionsV2: {
    params: null,
    monitorUcid: null,
    agentId: null,
    agentUniqId: null,
    customer: null,
  },
  tbSetDisposition: {
    params: null,
    callbacktz: null,
    monitorUcid: null,
    comments: null,
    tktDesc: null,
    tktCmnt: null,
    agentId: null,
    agentUniqId: null,
    customer: null,
    duration: null
  },
  pauseAfterSession: {
    agentId: null,
    agentUniqId: null,
    customer: null,
  },
  tbInitiateAgentCall: {
    phoneNumber: null,
    apiKey: null,
    agentId: null,
    agentUniqId: null,
    customer: null,
  },
  tbGetAgentPerformance: {
    agentId: null,
    agentUniqId: null,
    customer: null,
  },
  tbGetAgentCallHist: {
    agentId: null,
    agentUniqId: null,
    customer: null,
  },
  tbGetPreviewCampaigns: {
    agentId: null,
    agentUniqId: null,
    customer: null,
    trueCallerFlag: null,
  },
  tbGetPreviewNumber: {
    params: null,
    agentId: null,
    agentUniqId: null,
    customer: null,
    campaignTrueCallerFlag: null,
  },
  tbClosePreviewNumber: {
    pId: null,
    phoneNumber: null,
    reason: null,
    remarks: null,
    agentId: null,
    agentUniqId: null,
    customer: null,
  },
  tbPreviewDial: {
    params: null,
    mode: null,
    phoneNumber: null,
    agentId: null,
    agentUniqId: null,
    customer: null,
  },
  tbSendSMS: {
    dest: null,
    msg: null,
    ucid: null,
    campId: null,
    campaign_name: null,
    agentId: null,
    agentUniqId: null,
    customer: null,
    templateId: null,
    entityId: null,
  },
  tbSendWhatsappMsg: {
    recipient: null,
    msg: null,
    ucid: null,
    campId: null,
    campaign_name: null,
    agentId: null,
    agentUniqId: null,
    customer: null,
    templateId: null,
    entityId: null,
    replacementText: null,
    templateName: null,
  },

  tbSetAgentMode: {
    params: null,
    reconnect: null,
    reconDet: null,
    phoneNumber: null,
    agentId: null,
    agentUniqId: null,
    customer: null,
  },
  tbMute: {
    phoneNumberToMute: null,
    monitorUcid: null,
    ucid: null,
    did: null,
    agentId: null,
    agentUniqId: null,
    customer: null,
  },
  tbUnMute: {
    phoneNumberToUnMute: null,
    monitorUcid: null,
    ucid: null,
    did: null,
    agentId: null,
    agentUniqId: null,
    customer: null,
  },
  tbGetUcidDetails: {
    monitorUcid: null,
    ucid: null,
    agentId: null,
    agentUniqId: null,
    customer: null,
  },
  tbGetIdleSIPAgentsList: {
    agentId: null,
    agentUniqId: null,
    customer: null,
  },
  tbInternalDial: {
    isSip: null,
    agentId: null,
    agentUniqId: null,
    customer: null,
    agentMode: null,
    agentNumber: null,
    receiverAgentNumber: null,
    receiverAgentId: null,
    uui: "",
    obdJava: false,
  },
  tbGetIdleAgentCountBySkill: {
    userId: null,
    skillName: null,
    type: null,
  },
  tbCallHangupExplicit: {
    ucid: null,
    monitorUcid: null,
    campaignId: null,
    did: null,
    callType: "",
    agentId: "",
  },
  tbParkingChatCount: {
    customer: null,
    agentId: null,
  },
  tbAssignParkingChat: {
    customer: null,
    agentId: null,
    channelType: null
  },
  tbGetAgentWhatsappChatHist: {
    agentId: null,
    customer: null
  },
  tbGetAgentSmsChatHist: {
    agentId: null,
    customer: null
  },
  tbGetAgentIncomingChatHist: {
    agentId: null,
    customer: null
  },
  tbSetAgentState: {
    agentId: null,
    customer: null,
    agentUniqId: null,
    state: null,
    stateReason: null,
    mode: null
  },
  tbAgentRefresh: {
    customer: null,
    agentId: null,
    userId: null,
    mode: null,
    agentUniqId: null,
  },
  tbCloseTab: {
    customer: null,
    agentId: null,
    userId: null,
    mode: null,
    agentUniqId: null,
  },
  tbChatDispSuggetions: {
    customer: null,
    agentId: null,
    mode: null,
    agentUniqId: null,
    sessionId: null
  },
  tbAddPauseOnCall: {
    agentId: null,
    agentUniqId: null,
    customer: null,
    reason: null,
    ucid: null,
    pauseTime: null,
    utid: null,
  },
  tbRemovePauseOnCall: {
    agentId: null,
    agentUniqId: null,
    customer: null,
    utid: null,
  },
  HEALTH_CHECK: {
    agentId: null,
    agentUniqId: null,
    customer: null,
  },

  tbPauseMonitor: {
    type: "tbPauseMonitor",
    customer: null,
    apiKey: null,
    ucid: null,
    phoneNo: null,
    did: null,
    agentNumber: null,
    ccucid: null
  },

  tbUnPauseMonitor: {
    type: "tbUnPauseMonitor",
    customer: null,
    apiKey: null,
    ucid: null,
    phoneNo: null,
    did: null,
    agentNumber: null,
    ccucid: null
  },
  tbGetWhatsappMsgStatus: {
    utid: null,
    agentId: null,
    agentUniqId: null,
    customer: null,
    campId: null,
    callerNumber: null,
    userId: null,
    id: null,
    messageSentDate: null
  },
  tbGetWhatsappOutboundMsgs: {
    type: "tbGetWhatsappOutboundMsgs",
    agentId: null,
    agentUniqId: null,
    customer: null,
    userId: null,
    custNumber: null,
    limit: null,
  }
  ,
  tbGetSMSOutboundMsgs: {
    type: "tbGetSMSOutboundMsgs",
    agentId: null,
    agentUniqId: null,
    customer: null,
    userId: null,
    custNumber: null,
    limit: null,
  },
  tbSetAgentAudioSettings: {
    agentId: null,
    agentUniqId: null,
    customer: null,
    audioSettings: null
  },
  tbGetAgentAudioSettings: {
    agentId: null,
    agentUniqId: null,
    customer: null,
  },
  tbStartVideoScreenRecording: {
    agentId: null,
    agentUniqId: null,
    customer: null,
    utid: null,
    ucid: null,
    videoUrl: null
  },
  multiAgentEmailMsg: {
    agentId: null,
    agentUniqId: null,
    customer: null,
    chatCustSessionId: null,
    text: null,
    messageId: null,
    attachments: null,
    isFirstReply: true
  },
  tbGetEmailConversation: {
    agentId: null,
    agentUniqId: null,
    threadId: null,
    customer: null,
    offset: 1,
    limit: 5,
  }
};
export function buildRequest(reqType, data) {
  try {
    reqCounter = reqCounter + 1;
    let body = {
      ns: "ozonetel.cloudagent",
      type: reqType,
      usId: store.getState().toolbar.usId,
      utid: reqCounter,
      timestamp: Date.now(),
      reqTimestamp: new Date().toString(),
      browserSessionId: getBrowserSessionId()
    };
    let requestParams = REQUEST_MAPPER[reqType];
    if (requestParams) {
      for (const param in requestParams) {
        if (data.hasOwnProperty(param)) {
          body[param] = data[param];
        } else {
          body[param] = requestParams[param];
        }
      }
      if (reqType === "tbSetTransfer") {
        if (data && data.record === false) {
          body["record"] = "false";
        }
      }
      if (reqType === "tbSendSMS") {
        body.did = data.did;
        body.ucid = "";
        body.vendor = data.vendor;
        body.msg_type = data?.msg_type || '';
        body.media_url = data?.media_url || '';
        body.templateName = data.templateName;
        body.client_id = data.client_id;
      }
      if (reqType === "tbGetIdleAgentCountBySkill") {
        delete body.usId;
      }
      if (reqType === "tbSendWhatsappMsg") {
        body.did = data.did;
        body.templateName = data.templateName;
        body.client_id = data.client_id;
      }
      let agentData = getAgentData();
      if (requestParams.hasOwnProperty("agentId")) {
        body.agentId = agentData.agentInfo.agentId;
      }
      if (requestParams.hasOwnProperty("agentUniqId")) {
        body.agentUniqId = parseInt(agentData.agentUniqId);
      }
      if (requestParams.hasOwnProperty("customer")) {
        body.customer = agentData.customer;
      }
      if (requestParams.hasOwnProperty("phoneNumber")) {
        body.phoneNumber = agentData.phoneNumber;
      }

      if (requestParams.hasOwnProperty("agentName")) {
        body.agentName = agentData.agentInfo.agentName;
      }

      if (requestParams.hasOwnProperty("isSip")) {
        body.isSip = agentData.isSip.toString();
      }
      if (requestParams.hasOwnProperty("agentUserName")) {
        body.agentName = agentData.agentUserName;
      }
      if (requestParams.hasOwnProperty("agentName")) {
        body.agentName = agentData.agentInfo.agentName;
      }
      if (requestParams.hasOwnProperty("agentNumber")) {
        body.agentNumber = agentData.phoneNumber;
      }
      if (requestParams.hasOwnProperty("apiKey")) {
        body.apiKey = agentData.agentInfo.user.apiKey;
        if (requestParams?.type?.includes("tbPauseMonitor") || requestParams?.type?.includes("tbUnPauseMonitor")) {
          body.apiKey = data.apiKey;
        }
      }
      return body;
    } else {
      console.log(reqType + ": not availabe in service");
    }
  } catch (e) {
    console.log("error while building agent service request");
    return null;
  }
}
export function getHeaders() {
  let data = getAgentData();
  let user = data?.agentInfo?.user;
  let headers = {
    Authorization:
      "Basic " + btoa(data.customer + ":" + user?.apiKey),
    "Access-Control-Allow-Origin": "*", // Adjust the allowed origin as needed
    "Access-Control-Allow-Headers": "Content-Type", // Adjust the allowed headers as needed
    userName: user?.username,
    apiKey: user?.apiKey,
    "X-MDL": data["x-mdl-ip"] ?? ''
  };
  return headers;
}
export async function agentService(reqType, data) {
  try {
    let reqBody = buildRequest(reqType, data);
    let timeout = 30000;
    if (reqType === 'tbSetDisposition') {
      timeout = 7500
      console.log("sending disposition request")
    }
    if (reqBody) {
      let responseData = await HttpService.postWithHeaders(
        "agentUrl",
        reqBody,
        getHeaders(),
        timeout
      );
      if (responseData?.latestToken) {
        const latestToken = { ...JSON.parse(responseData.latestToken), reconnect: false };
        if (latestToken.type === 'toolbarLogout') {
          console.log("Session terminated — a new session has been initiated on another device");
          WSocketService.setAgentForceLogoutByAdmin(true);
          clearSession(false, true); // toolbarLogout -> redirect to login page
        }
      }
      return responseData;
    } else {
      return null;
    }
  } catch (e) {
    console.log("error while handling" + reqType, e);
  }
}
export const getQueueChatsCount = async (play = true) => {
  try {
    const resp = await agentService("tbParkingChatCount", {});
    if (resp.status === "success") {
      const whatsappCount = Number(resp?.count || 0);
      const smsCount = Number(resp?.smsCount || 0);
      const email = Number(resp?.emailCount || 0);
      const totalParking = whatsappCount + smsCount;
      store.dispatch(setParkingChatsCount({ whatsapp: whatsappCount, sms: smsCount, email: email }));
      if (totalParking > 0) {
        // showInfoNotification(`You have ${totalParking} chats in parking.`);
        showClickableSnackbar(
          `You have ${totalParking} chats in parking.`,
          () => { store.dispatch(handlePullChatsDialog(true)); });
        if (play) {
          playMsgAlert();
        }
      }
      return resp;
    } else {
      showErrorNotification(resp.message);
      return 0;
    }
  } catch (error) {
    console.error(error);
    return 0;
  }
};
export async function agentLogin(data) {
  try {
    data["action"] = "formLogin";
    data["redirectURL"] = "";
    data["isMobileDevice"] = isMobileDevice();
    let headers = { "Content-Type": "application/x-www-form-urlencoded" };
    let responseData = await HttpService.postWithHeaders(data?.sso ? "login_sso" : "login", data, headers);
    return responseData;
  } catch (e) {
    console.log("error while login", e);
  }
}
export async function VerifyOTP(data) {
  try {
    let headers = {
      "Content-Type": "*",
      "Access-Control-Allow-Origin": "*",
    };
    let agentData = getAgentData();
    let reqBody = {
      otp: data.otp,
      api_key: data.api_key,
      type: "CA",
      agentId: ((agentData?.customer ?? '') + (data?.agentId ?? '')).toString().toLowerCase(),
    }
    if (data.type === 'sms') {
      reqBody.phone_no = data.phone_no;
    }
    if (data.type === 'email') {
      reqBody.email = data.email;
    }
    let responseData = await HttpService.otpVerify("otp", reqBody, headers);
    return responseData;
  } catch (e) {
    console.log("Login MFA Error", e);
  }
}
export async function sendOTP(data) {
  try {
    const reqBody = {
      type: "CA",
      sender_id: "OZONTL",
      agentId: data.agentId,
      phone_no: data.phone_no,
      api_key: data.api_key,
    };
    let headers = {
      "Content-Type": "*",
      "Access-Control-Allow-Origin": "*",
    };
    let responseData = await HttpService.get("sendOTP", reqBody, headers);
    return responseData;
  } catch (e) {
    console.log("Login MFA Resend Error", e);
  }
}
export async function SendOTPtoAgent(otpType) {
  const agentData = getAgentData(); // Fetch agent data
  try {
    const reqBody = {
      type: otpType,
      agentId: (agentData?.agentInfo?.agentId || '').toString().toLowerCase(),
      phoneNumber: agentData?.phoneNumber ?? ''
    };

    // Get headers
    const headers = getAdminHeadersToken();

    // Make the API call
    const responseData = await HttpService.postWithHeaders("sendOTP", reqBody, headers);

    return responseData;  // Return the response

  } catch (e) {
    console.error("Error while sending OTP", e);  // Log the error properly
    return { error: true, message: 'Failed to send OTP' };  // Fallback response
  }
}
export async function agentForceLogout(username, agentid) {
  try {
    var formData = new FormData();
    formData.append("action", "logMeOut");
    formData.append("username", username);
    formData.append("agentId", agentid);
    formData.append("who", "agent");
    let loginRespData = await HttpService.post("logout", formData);
    return loginRespData;
  } catch (e) {
    console.log("eror while force logout", e);
  }
}
function getAdminHeadersToken() {
  const adminToken = store.getState().toolbar.adminToken;
  let headers = {
    Authorization: "Bearer " + adminToken,
    "Access-Control-Allow-Origin": "*", // Adjust the allowed origin as needed
    "Access-Control-Allow-Headers": "Content-Type", // Adjust the allowed headers as needed
    UserId: getUserId(),
  };
  return headers;
}
export async function getPerformanceTabData(reqBody) {
  try {
    let isValid = await isTokenValid();
    if (isValid) {
      let url = HttpService.getURL('performance');
      const finaleURL = constructURL(url, reqBody?.apiId, reqBody?.UserId, reqBody?.AgentId);
      const response = await fetch(finaleURL, {
        method: 'POST',
        headers: getDashBoardHeaders(),
        body: JSON.stringify(reqBody)
      });
      return response.json();
    }
  } catch (e) {
    console.log("error while fetching performance data", e);
    Logger.info("error while fetching performance data", e);
  }
}
export async function getEmailConversation(reqBody) {
  try {
    let emailConversation = await HttpService.get("email_interaction", reqBody);
    if (emailConversation) {
      store.dispatch(
        setEmailData({ type: "emailData", value: emailConversation })
      );
      store.dispatch(
        setEmailData({
          type: "body",
          value:
            emailConversation &&
            emailConversation.data &&
            emailConversation.data.conversation &&
            emailConversation.data.conversation.data,
        })
      );
      store.dispatch(
        setEmailData({
          type: "emailBody",
          value:
            emailConversation &&
            emailConversation.data &&
            emailConversation.data.conversation &&
            emailConversation.data.conversation.data,
        })
      );
    }
  } catch (e) {
    console.log("", e);
  }
}
export async function sendMail(emailInfo) {
  store.dispatch(loading(true));
  let conversationDetails =
    emailInfo && emailInfo.data && emailInfo.data.conversation;

  try {
    let reqBody = {
      from: conversationDetails.to,
      to: conversationDetails.from,
      cc: conversationDetails.cc,
      bcc: conversationDetails.bcc,
      body: conversationDetails.data,
      subject: conversationDetails.subject,
      send_at: null,
      file_ids: [],
    };
    const queryParams = new URLSearchParams({
      message_id: conversationDetails.message_id,
      doc_id: conversationDetails._id,
    });
    let emailHeaders = {
      "Content-Type": "application/json",
      Authorization: emailInfo.config.key,
    };

    await fetch(emailInfo.config.url + "?" + queryParams.toString(), {
      method: "POST",
      headers: emailHeaders,
      body: JSON.stringify(reqBody),
    })
      .then((data) => {
        showSuccessNotification("Email send Successfully");
        store.dispatch(setEmailData({ type: "replayMail", value: false }));
        store.dispatch(loading(false));
      })
      .catch((error) => {
        store.dispatch(loading(false));
        console.log("Error:", error);
        showErrorNotification("Failed to send email..");
        store.dispatch(setEmailData({ type: "replayMail", value: true }));
      });
  } catch (e) {
    store.dispatch(loading(false));
    console.log("", e);
  }
}
export async function recordCall(action, data) {
  data.agentNumber = store.getState().toolbar.loginDetails.phoneNumber;
  data.api_key = store.getState().toolbar.loginDetails.agentInfo.user.apiKey;
  try {
    let params = {
      r: "CallControllers",
      action: action === true ? "UnPauseMonitor" : "PauseMonitor", //UnPauseMonitor  PauseMonitor
      api_key: app.call_recording_key,
      ucid: data.ucid, //callDetails.monitorUcid,
      phoneNo: data.phoneNo, //callDetails.callerId
      agentNumber: data.agentNumber, //agentLoginDetails.phoneNumber
      did: data.did, //callDetails.did
      ccucid: data.ccucid
    };
    let resp;
    resp = await HttpService.get("recording", params);
    return resp;
  } catch (e) {
    console.log("error updating call record ", e);
  }
}
export async function getChatDispositions(data) {
  try {
    let params = {
      apiKey: data.apiKey,
      customer: data.username,
      action: "get",
      campaignID: data.campaignId,
    };
    let resp = await HttpService.get("chat_disposition", params);
    return resp;
  } catch (e) {
    console.log("error while fetching chat dispistion", e);
  }
}
export async function uploadMultimedia(data) {
  try {
    let resp = await HttpService.post("chat_upload", data);
    return resp;
  } catch (e) {
    console.log("error while uploading file", e);
  }
}
export async function getCustomerInfo(data) {
  try {
    let params = {
      ns: "ozonetel.cloudagent",
      type: "tbGetCustomerData",
      params: data.dataId || "",
      callType: data.callType,
      monitorUcid: data.monitorUcid,
      agentId: data.agentUserName,
      agentUniqId: data.agentUniqId,
      customer: data.customer,
    };
    let resp = await HttpService.get("customer_info", params);
    return resp;
  } catch (e) {
    console.log("error while fetching customer info", e);
  }
}
export function authUser() {
  return localStorage.getItem("isLoggedIn") || false;
}
export const getPerformanceDetails = (data) => {
  let params = {
    agentId: data.agentInfo.agentId,
  };
  let res = HttpService.getWithHeaders("performance", params, getHeaders());
  return res;
};
export async function getSuggestionLists(message, campaignId = null) {
  try {
    const params = { text: message, campaignId: campaignId };
    const url = HttpService.getURL("agentAssist") + "/agent_assist";
    let res = await HttpService.getByUrl(url, params);
    return res;
  } catch (e) {
    console.log("error while fetching suggestions", e);
  }
}
export async function getSuggestionListV2(ucid = null, data) {
  try {
    const params = { ucid: ucid };
    const url = HttpService.getURL("agentAssist") + "/agent_assist";
    let res = await HttpService.postByURL(url, data, { params: params });
    return res;
  } catch (e) {
    console.log("error while fetching suggestions", e);
  }
}
export const getChatSuggestionsBasedOnMessage = async (message) => {
  try {
    const params = { text: message };
    const url = HttpService.getURL("agentAssist") + "/rephrase_reply";
    let res = await HttpService.getByUrl(url, params);
    return res;
  } catch (e) {
    console.log("error while fetching chat suggestion", e);
  }
}
const smartReplyParams = {
  language: "en-IN",
  sid: "some unique id for tracking (optional)",
};
//smart replies which should be displayed above chat
export async function getSmartReplies(message) {
  const params = {
    ...smartReplyParams,
    q: message,
    project_name:
      getAgentData().agentInfo !== undefined
        ? getAgentData().agentInfo.user.username
        : "",
  };
  let res = HttpService.postWithHeaders("smartAssistFetch", params, {
    "Access-Control-Allow-Origin": "*",
  });
  return res;
}
//update the model using Username/Id as project name with question and answer combination
export async function UpdateSmartRepliesModel(question, answer) {
  const params = {
    ...smartReplyParams,
    q: question,
    a: answer,
    project_name:
      getAgentData().agentInfo !== undefined
        ? getAgentData().agentInfo.user.username
        : "",
  };
  let res = HttpService.postWithHeaders("smartAssistUpdate", params, {
    "Access-Control-Allow-Origin": "*",
  });
  return res;
}
export async function getCallHistory(ucids) {
  let data = getAgentData();
  try {
    let params = {
      clientId: LocalStorageService.getItem("usId"),
      ucids: ucids.join(","),
      agentId: data.agentUniqId,
      apiKey: data.agentInfo.user.apiKey,
      userName: data.customer,
    };
    let resp = await HttpService.get("call_history", params);
    return resp;
  } catch (e) {
    console.log("error while fetching call history", e);
  }
}
export async function getChatHistoryDownload(params) {
  try {
    let chatHistory = await HttpService.get("chatHistory", params);
    return chatHistory;
  } catch (e) {
    console.log("chat history download failed", e);
  }
}
export const filterTypes = [
  { id: 1, label: "Campaign", value: "Campaign" },
  { id: 2, label: "Skill", value: "Skill" },
  { id: 3, label: "Group", value: "Group" },
];
export const filterTypesForQueuecounter = [
  { id: 1, label: "Campaign", value: "Campaign" },
  { id: 2, label: "Skill", value: "Skill" },
];
export async function loginAdmin() {
  try {
    const loginData = store.getState()?.toolbar?.loginDetails || {};
    const headers = { "Content-Type": "application/json" };
    const authType = loginData?.agentInfo?.user?.authType?.toLowerCase();
    let preLoginResp = await preLogin();
    if (!preLoginResp?.publicKey || !preLoginResp?.keyId) {
      throw new Error('INVALID_PRELOGIN_RESPONSE');
    }
    const encrypt = new JSEncrypt();
    encrypt.setPublicKey(preLoginResp.publicKey);
    let data = {
      username: encrypt.encrypt(loginData.agentInfo.user.username),
      agentId: encrypt.encrypt(loginData.agentInfo.agentId),
      password: encrypt.encrypt(loginData?.agentKey || ""),
      keyId: preLoginResp.keyId,
      agent: "true"
    };

    const ROLE_TAPI_LOGIN = getRoleStatus("ROLE_TAPI_LOGIN");
    if (ROLE_TAPI_LOGIN){
        data.isAgentAdminMapping = true;
        data.apiKey = store.getState().toolbar.loginDetails.agentInfo.user.apiKey;
    }

    if (authType === "ldap") {
      data = { ...data };
    } else {
      data.agentName = encrypt.encrypt(loginData?.agentInfo?.agentName);
    }

    const resp = await HttpService.postWithHeaders(
      "adminAuthUrl",
      JSON.stringify(data),
      headers
    );
    return resp;
  } catch (e) {
    console.log(e);
  }
}
async function getToken(decoded) {
  const refreshToken = store.getState().toolbar.refreshToken;
  try {
    let payload = {
      refreshToken: refreshToken,
      username: store.getState().toolbar.loginDetails.agentInfo.user.username,
      apiKey: decoded.apiKey,
    };
    const headers = getDashBoardHeaders();
    const resp = await HttpService.postWithHeaders(
      "generateToken",
      payload,
      headers
    ); // generating new token
    if (resp && resp.token) {
      console.log("new token generated");
      store.dispatch(setAdminToken(resp.token));
      store.dispatch(setRefreshToken(resp.refreshToken));
      return true;
    } else {
      console.log("failed to generated new token ");
      return false;
    }
  } catch (e) {
    console.log("error: while generating new token ", e);
  }
}
export async function isTokenValid() {
  try {
    const adminToken = store.getState().toolbar.adminToken;
    const decoded = jwtDecode(adminToken);
    const currentTime = Date.now() / 1000; // Current time in seconds
    if (decoded.exp < currentTime) {
      console.log("token expired--------->"); // token expired
      return await getToken(decoded);
    } else {
      return true; // token not expired
    }
  } catch (error) {
    console.error("Error decoding token:", error);
    return false;
  }
}
export function getDashBoardHeaders() {
  const adminToken = store.getState().toolbar.adminToken
  let headers = {
    "Access-Control-Allow-Origin": "*",
    "Content-Type": "application/json",
    Authorization: `Bearer ${adminToken}`,
    userId: getUserId(),
  };
  return headers;
}
export async function getQaAgentDetails(data) {
  let isValid = await isTokenValid();
  if (isValid) {
    let url = HttpService.getURL('qa_agent_details');
    const response = await fetch(url, {
      method: 'POST',
      headers: getDashBoardHeaders(),
      body: JSON.stringify(data)
    });
    return response.json();
  }
}
export async function getDashboardData(data) {
  let isValid = await isTokenValid();
  if (isValid) {
    let url = HttpService.getURL('dashboard');
    const finaleURL = constructURL(url, data?.apiId, data?.UserId, data?.AgentId);
    const response = await fetch(finaleURL, {
      method: 'POST',
      headers: getDashBoardHeaders(),
      body: JSON.stringify(data)
    });
    return response.json();
  }
}
export async function getIVRJourney() {
  const calldata = store.getState().call;

  if (calldata && calldata.callDetails) {
    let payload = {
      monitorUCID: calldata.callDetails.monitorUcid,
    };
    let responseData = await HttpService.get("IVR_Journey", payload);
    let parcedData =
      responseData && responseData.map((item) => JSON.parse(item));
    store.dispatch(setIVRcheckpointData(parcedData));
  }
}
export async function getFilters(apiId) {
  let isValid = await isTokenValid();
  if (isValid) {
    let responseData = await HttpService.postWithHeaders(
      "dashboard",
      JSON.stringify({ apiId: apiId, UserId: getUserId(), AccessType: "Data" }),
      getDashBoardHeaders()
    );
    return responseData;
  }
}
export async function getFiltersAgentList(apiId) {
  let isValid = await isTokenValid();
  if (isValid) {
    let agentData = getAgentData();
    let responseData = await HttpService.postWithHeaders(
      "dashboardAgentListFilter",
      JSON.stringify({ apiId: apiId, UserId: getUserId(), AgentId: parseInt(agentData.agentUniqId) }),
      getDashBoardHeaders()
    );
    return responseData;
  }
}
export const getCrmInfo = async (event) => {
  try {
    const headers = {
      "Content-Type": "application/json",
      Authorization:
        "Basic " +
        btoa(
          store.getState().toolbar.loginDetails.customer +
          ":" +
          store.getState().toolbar.loginDetails.agentInfo.user.apiKey
        ),
    };
    const data = {
      ucid: event.data.ucid,
      token: event.data.token,
    };
    const resp = await HttpService.postWithHeaders("crm_Info", data, headers);
    return resp;
  } catch (e) {
    console.log(e);
  }
};
export const getChatHistoryTableData = async (data) => {
  const headers = { "Content-Type": "application/json" };
  try {
    const resp = await HttpService.postWithHeaders(
      "chatHistoryTable",
      JSON.stringify(data),
      headers
    );
    return resp;
  } catch (e) {
    console.log(e);
  }
};
export const getWhatsAppDidList = async () => {
  const headers = {
    "Access-Control-Allow-Origin": "*",
  };
  let params = {
    userName: getAgentData().customer,
    apiKey: getAgentData().agentInfo.user.apiKey,
    agentId: getAgentData().agentInfo.agentId,
  };
  try {
    const resp = await HttpService.getWithHeaders(
      "whatsAppDids",
      params,
      headers
    );
    return resp;
  } catch (e) {
    console.log(e);
  }
};
export async function getTransferList({ tabValueState }) {
  store.dispatch(loading(true));
  const { callDetails: callData } = store.getState().call;
  try {
    let reqBody = {
      did: callData.did,
      campId: callData.campaignId,
      transferType:
        tabValueState === "Agent"
          ? 1
          : tabValueState === "Skill"
            ? 2
            : tabValueState === "Phone"
              ? 3
              : 4,
    }
    const resp = await agentService("tbGetTransferList", reqBody);
    if (resp?.status === "Success") {
      if (tabValueState === "Skill") {
        store.dispatch(
          setSkillTransfer(
            resp.skillTransfer && resp.skillTransfer
              ? resp.skillTransfer
              : false
          )
        );
      } else {
        store.dispatch(setSkillTransfer(false));
      }
      store.dispatch(loading(false));
      return resp.message;
    } else {
      store.dispatch(setSkillTransfer(false));
      Logger.error("tbGetTransferList resp: error ");
      store.dispatch(loading(false));
      return [];
    }
  } catch (e) {
    store.dispatch(setSkillTransfer(false));
    store.dispatch(loading(false));
    Logger.error(e);
    return [];
  }
}
export async function getSkillTransferAgentCount(data) {
  try {
    const resp = await agentService("", data);
    if (resp.status === "Success") {
      return resp.message;
    } else {
      Logger.error("resp: getSkillTransferAgentCount");
    }
  } catch (e) {
    Logger.error(e);
  }
}
const displayErrorNotification = (message) => {
  showErrorNotification(message);
  store.dispatch(loading(false));
};
export async function setTransferCall({
  typeOfTransfer = 1,
  transferValue,
  tabValueState,
  transferList,
  monitorUcid = null,
  allowRecording = false,
  handleCloseTransfer,
  setTransferValue,
  triggeredBy3rdParty = true,
  transferAgentId,
  setTransferedAgentId,
  transferComments = '',
}) {
  const dispatch = store.dispatch;
  dispatch(loading(true));
  const {
    callDetails: callData,
    transferData,
    conferenceData,
    isCallAttended,
  } = store.getState().call;
  if (!isCallAttended) {
    displayErrorNotification("No Active Call found to Transfer");
    return;
  }
  if (triggeredBy3rdParty && monitorUcid !== callData.monitorUcid) {
    displayErrorNotification("Please use the same ticket to transfer the call");
    return;
  }
  if (transferData.length >= 1) {
    displayErrorNotification("Cannot Connect two Transfer call at a same Time");
    return;
  }
  if (conferenceData.length >= 1) {
    displayErrorNotification(
      "Cannot Connect Transfer and Conference both at a same Time"
    );
    return;
  }
  let transferLists =
    transferAgentId !== undefined && transferAgentId !== null
      ? transferAgentId
      : transferValue;
  let transferType =
    tabValueState === "Agent"
      ? 1
      : tabValueState === "Skill"
        ? 2
        : tabValueState === "Phone"
          ? 3
          : 4;
  let blindTransferByPhoneKey = tabValueState === "Phone" ? -2 : "";
  let defaultIvr = tabValueState === "IVR" ? transferValue : "";
  let skillUrl =
    getParam("SKILL_TRANS_URL") ||
    "http://localhost/ca_manual_ivr/ivr/skill_transfer.php%22";

  if (transferValue === null) {
    showWarningNotification(
      "Please select any Number or Agent or Skill or Ivr"
    );
  }

  const getTransferValueForPhone = (transferLists) => {
    if (transferLists && transferLists.split("~")[1]) {
      return transferLists.split("~")[1];
    } else {
      return transferLists;
    }
  };

  if (tabValueState === "IVR") {
    let isIvrPresent = false;
    if (triggeredBy3rdParty) {
      transferList = await getTransferList({ tabValueState });
    }
    transferList.forEach((data) => {
      if (data.flowName === transferValue) {
        transferLists = data.flowId;
        isIvrPresent = true;
      }
    });
    if (!isIvrPresent) {
      displayErrorNotification("Please provide a valid IVR");
      return;
    }
  }

  const getSkillTransferType = () => {
    let isSkillTransfer = store.getState().toolbar.isSkillTransfer;
    if (isSkillTransfer) {
      let value = transferValue;

      return `${value}#T`;
    } else {
      return transferLists;
    }
  };

  const getTransferPhoneSipValue = (requestPhoneNumber, transferList) => {
    try {
      if (typeof requestPhoneNumber === 'string') {
        const phoneNumber = requestPhoneNumber?.split("~")[1];
        return transferList?.find(data => data.transferNumber === phoneNumber)?.sip || false;
      } else {
        return false;
      }
    } catch (error) {
      console.log("Failed to parse transferList:", error);
      return false;
    }

  };

  const params =
    tabValueState === "IVR"
      ? (callData.did || "") +
      "," +
      (callData.ucid || "") +
      "," +
      transferType +
      "," +
      transferLists +
      "," +
      "" +
      "," +
      typeOfTransfer +
      "," +
      defaultIvr +
      "," +
      skillUrl //for ivr it is correct
      : tabValueState === "Skill"
        ? (callData.did || "") +
        "," +
        (callData.ucid || "") +
        "," +
        transferType +
        "," +
        getSkillTransferType() +
        "," +
        "" +
        "," +
        typeOfTransfer +
        "," +
        "" +
        "," +
        skillUrl // for skill it is correct
        : tabValueState === "Phone"
          ? (callData.did || "") +
          "," +
          (callData.ucid || "") +
          "," +
          transferType +
          "," +
          blindTransferByPhoneKey +
          "," +
          getTransferValueForPhone(transferLists) +
          "," +
          typeOfTransfer +
          "," +
          skillUrl //for Phone it is correct
          : tabValueState === "Agent"
            ? (callData.did || "") +
            "," +
            (callData.ucid || "") +
            "," +
            transferType +
            "," +
            transferLists +
            "," +
            "" +
            "," +
            typeOfTransfer +
            "," +
            skillUrl
            : ""; //for Agent it is correct
  const disableHoldButton = () => {
    try {
      if (typeof window !== "undefined") {
        return window?.location?.href.includes('dishtv');
      }
      return false;
    } catch (e) {
      Logger.info("hold button disable error ");
      return false;
    }
  };
  try {
    let reqBody = {
      params: params,
      sip: transferType === 3 ? getTransferPhoneSipValue(transferLists, transferList) : false,
      monitorUcid: callData.monitorUcid || "",
      custNumber: callData.callerId || "",
      campId: callData.campaignId || "",
      callType: callData.callType || "",
      skillName: callData.skillName || "",
      crmInfo: JSON.stringify(callData.crm_info || {}) || "",
      uui: callData.uui || "",
      transferComments: transferComments.slice(0, 100),
    };
    if (!allowRecording && typeOfTransfer === 3) {
      reqBody.record = false;
    }

    agentService("tbSetTransfer", reqBody)
      .then((resp) => {
        if (resp.status === "Success") {
          showSuccessNotification("Transfer Call Connected Successfully.");
          Logger.info("transfer call connected successfully");
          if (typeOfTransfer === 3 && disableHoldButton()) {
            dispatch(setWarmTransferdisableHoldButton(true));
          }
          if (tabValueState === "Agent") {
            let number = resp.message.split("(");
            number = number[1].split(":");
            number = number[1].split(")");
            aToolbar !== undefined &&
              aToolbar.trigger("transfer", [
                callData,
                tabValueState,
                number[0],
              ]);
          } else {
            aToolbar !== undefined &&
              aToolbar.trigger("transfer", [
                callData,
                tabValueState,
                transferLists,
              ]);
          }

          !triggeredBy3rdParty && handleCloseTransfer();
          if (typeOfTransfer === 1 && tabValueState !== "IVR") {
            endCurrentCall();
          }
          if (typeOfTransfer === 3) {
            if (tabValueState === "Agent") {
              let number = resp.message.split("(");
              number = number[1].split(":");
              number = number[1].split(")");
              dispatch(
                addTransferNumber({
                  person: number[0],
                  onHoldState: false,
                  text: transferValue,
                })
              );
              dispatch(setCallControlsActions({ isCallOnHold: true }));
            } else {
              dispatch(
                addTransferNumber({
                  person: transferValue,
                  onHoldState: false,
                  text: transferValue,
                })
              );
              dispatch(setCallControlsActions({ isCallOnHold: true }));
            }
          }
          dispatch(clearTransferComments());
          dispatch(loading(false));
          !triggeredBy3rdParty && setTransferValue(null);
          setTransferedAgentId(null);
        } else if (resp.status === "Error") {
          Logger.info(resp.message);
          showErrorNotification(
            resp.message !== "" ? resp.message : "Call Transfer Failed"
          );
          dispatch(clearTransferComments());
          !triggeredBy3rdParty && handleCloseTransfer();
          dispatch(loading(false));
          !triggeredBy3rdParty && setTransferValue(null);
          !triggeredBy3rdParty && setTransferedAgentId(null);
        } else {
          showErrorNotification("Call Transfer Failed");
          Logger.info("transfer call failed");
          dispatch(clearTransferComments());
          dispatch(loading(false));
          !triggeredBy3rdParty && setTransferValue(null);
          !triggeredBy3rdParty && setTransferedAgentId(null);
        }
      })
      .catch((e) => {
        Logger.error(e);
        dispatch(loading(false));
      });
  } catch (e) {
    showErrorNotification("Unable to Transfer the Call");
    Logger.error(e);
    dispatch(loading(false));
  }
}
export async function getdispositionListForExternalApps() {
  const dispatch = store.dispatch;
  const callData = store.getState().call.callDetails;
  const mode = store.getState().toolbar.agent.mode;

  const params =
    (callData.did || "") + "~" + mode + "~" + (callData.campaignId || "");

  try {
    dispatch(loading(true));
    const resp = await agentService("tbGetDispositions", {
      params: params,
      monitorUcid: callData.monitorUcid,
    });

    if (resp.resp === "Success") {
      let dispData = JSON.parse(resp.dispList);
      let dispositionKeys = Object.values(dispData);
      const filtered = dispositionKeys.filter((e) => e !== "callBack");
      Logger.info("Successfully accessed disposition list");
      dispatch(loading(false));
      return filtered;
    } else {
      Logger.info(`${resp.message}. Unable to get dispositions list`);
      showWarningNotification(
        "Unable to get disposition list so dispose of call is not possible.",
        resp.message
      );
      dispatch(loading(false));
      return null;
    }
  } catch (e) {
    Logger.error(e);
    showWarningNotification(
      "Unable to get disposition list so dispose of call is not possible.",
      e
    );
    dispatch(loading(false));
    return null;
  }
}
export async function disposeViaExternalApps({
  dateandTime,
  comments,
  disposition,
  timezone,
  pauseAgentAfterDisposition,
  pauseReason,
}) {
  const dispatch = store.dispatch;
  const callData = store.getState().call.callDetails;
  const multiDisp = store.getState().toolbar.multiDisposition;
  dispatch(loading(true));

  try {
    let params =
      (callData.dataId || "") +
      "," +
      disposition +
      "," +
      (dateandTime !== null ? dateandTime : "") +
      "," +
      callData.ucid +
      "," +
      callData.did +
      "," +
      callData.callerId +
      "," +
      callData.uui;

    let reqBody = {
      params: params,
      callbacktz: timezone,
      comments: comments,
      tktDesc: "",
      tktCmnt: "",
      monitorUcid: callData.monitorUcid,
    };

    const resp = await agentService("tbSetDisposition", reqBody);

    if (resp.resp === "success") {
      if (store.getState().toolbar.params.DONT_CLOSE_SPOP === "false") {
        handleScreenPopClose(callData.ucid, 'call');
        dispatch(removeTab('Pop CRM'));
        removeScreenpopFromStorage('Pop CRM');
        dispatch(setScreenpopURL(null));
      }
      closeAllPreviewScreenpops();
      dispatch(removeTab('Script'));
      if (aToolbar !== undefined) {
        aToolbar.trigger("setDisposition", [
          callData,
          disposition,
          comments,
          dateandTime || "",
        ]);
      }

      let eventListerObj = {};
      eventListerObj["callData"] = callData;
      eventListerObj["disposition"] = disposition;
      eventListerObj["dispositionComments"] = comments;
      eventListerObj["callBackTimezone"] = timezone;
      eventListerObj["callBackDateAndTime"] = dateandTime;
      window.parent.postMessage(
        { action: "setDisposition", token: eventListerObj },
        "*"
      );

      let disObj = structuredClone(multiDisp);
      disObj.disp1 = null;
      disObj.disp2 = null;
      disObj.disp3 = null;
      disObj.disp4 = null;
      disObj.disp5 = null;

      disObj.disp1SelectedValue = null;
      disObj.disp2SelectedValue = null;
      disObj.disp3SelectedValue = null;
      disObj.disp4SelectedValue = null;
      disObj.disp5SelectedValue = null;

      dispatch(setDispositionReqbody(null));
      dispatch(handleMultiDisposition(disObj));
      dispatch(handleDispositionEnable(false));

      dispatch(
        setDispositionValues({
          rescheduleDateTime: null,
          rescheduleComment: null,
          reason: null,
          pauseReasonState: false,
          callBackTimezoneSelected: null,
        })
      );
      dispatch(
        setCurrentLocationTimeAndRescheduleTime({
          currentLocationTime: null,
          rescheduleDateTime: null,
        })
      );

      LocalStorageService.removeItem("rescheduleDateAndTime");
      LocalStorageService.removeItem("CancelDispositionScreen");
      LocalStorageService.removeItem("dispDateAndTime");
      localStorage.removeItem('timeTakenToSub');
      LocalStorageService.removeItem("dispComment");
      LocalStorageService.removeItem("dispPauseState");
      LocalStorageService.removeItem("dispPauseReason");
      LocalStorageService.removeItem("dispZone");
      LocalStorageService.removeItem("dispCurrentLocationTime");
      LocalStorageService.removeItem("forceRedialAfterDispose");
      if (isUcidRecordingMode()) {
        handleScreenRecording("setDisposition", "pause");
        console.log("screen->Recording :: set disposition, Pausing the screen recording");
        const isBarginRecording = store.getState().toolbar.isBarginRecording;
        if (isBarginRecording) {
          console.log("screen->Recording :: bargin in progresss, so resuming the screen recording");
          updateScreenRecordingUcid('');
          handleScreenRecording("bargin", "resume");

        }
      }
      if (
        pauseAgentAfterDisposition !== undefined &&
        pauseAgentAfterDisposition !== null &&
        pauseAgentAfterDisposition === true
      ) {
        pauseAgent(pauseReason);
      } else {
        releaseAgent();
      }

      showSuccessNotification("Disposition added Successfully");
      Logger.info("Disposition Added successfully");
    } else {
      showErrorNotification(`${resp.message}. Disposition Submission Failed`);
      Logger.info(`${resp.message}. Disposition submission Failed`);
      dispatch(loading(false));
    }
  } catch (e) {
    showErrorNotification("Unable to set Disposition");
    Logger.error(e);
    dispatch(loading(false));
  }
}
export function triggerNewCall(callDetailsFromWebSocket) {
  try {
    if (callDetailsFromWebSocket && callDetailsFromWebSocket.type && callDetailsFromWebSocket.type === "newCall" && callDetailsFromWebSocket.monitorUcid && callDetailsFromWebSocket.skillName) {
      const isCustomerInfoAlreadyPresent = callDetailsFromWebSocket.custInfo && callDetailsFromWebSocket.custInfo.length && callDetailsFromWebSocket.custInfo.length > 0;
      if (!isCustomerInfoAlreadyPresent) {
        window.parent.postMessage({ action: "newCall", token: callDetailsFromWebSocket }, "*");
      }
    }
  }
  catch (e) {
    console.log("Error while triggering new call", e);
  }
}
export async function getCustomerInformation() {
  const {
    callDetails: callDetailsFromWebSocket,
    isComponentOnCall,
    isCallIncomming,
  } = store.getState().call;
  if (
    callDetailsFromWebSocket &&
    callDetailsFromWebSocket.callData !== "InBound" &&
    (isComponentOnCall || isCallIncomming)
  ) {
    let custInfoApiObj = {
      monitorUcid: callDetailsFromWebSocket.monitorUcid,
      agentUserName: getAgentData().agentInfo.agentId,
      agentUniqId: callDetailsFromWebSocket.agentUniqueID,
      customer: getAgentData().customer,
      dataId: callDetailsFromWebSocket.dataId,
      callType:
        callDetailsFromWebSocket.callData !== null &&
        (callDetailsFromWebSocket.callData === "Predictive"
          ? callDetailsFromWebSocket.callData
          : callDetailsFromWebSocket.callType),
    };
    if (
      callDetailsFromWebSocket.callType === "IncomingCall" &&
      callDetailsFromWebSocket.uui !== "" &&
      callDetailsFromWebSocket.uui.indexOf("info_") === 0
    ) {
      custInfoApiObj.dataId = callDetailsFromWebSocket.uui.replace(
        /info_/g,
        ""
      );
    }
    if (
      (custInfoApiObj.dataId === null || custInfoApiObj.dataId === "") &&
      callDetailsFromWebSocket.callData !== "Predictive"
    ) {
      custInfoApiObj.customer = {};
    }
    try {
      getCustomerInfo(custInfoApiObj)
        .then((resp) => {
          if (resp[""] === "error") {
            Logger.error("getCustomerInfo eroor");
            triggerNewCall(callDetailsFromWebSocket);
          } else {
            let cloneOfCustInfo = [];
            resp.custData.forEach((data) => {
              const objKey = data.split("~")[0];
              const objEntry = data.split("~")[1];
              if (objKey === "PhoneNumber") {
                cloneOfCustInfo.push({
                  name: objKey,
                  value: isMaskNumberEnabled(objEntry),
                });
              } else {
                cloneOfCustInfo.push({ name: objKey, value: objEntry });
              }
            });
            appendNewObjWithCallData({ custInfo: cloneOfCustInfo });
            Logger.log("Successfully got customer information");
            triggerNewCall(callDetailsFromWebSocket);
          }
        })
        .catch((e) => Logger.log(e));
    } catch (e) {
      Logger.log(e);
    }
  } else {
    triggerNewCall(callDetailsFromWebSocket);
  }
}
export function callControlsJsonList() {
  let callControlsList = store.getState().toolbar.loginDetails.callControls;
  if (
    callControlsList &&
    callControlsList !== null &&
    callControlsList !== "" &&
    Object.keys(callControlsList).length > 0
  ) {
    callControlsList = JSON.parse(callControlsList);
  }
  let callControlsJsonList = {
    mute:
      callControlsList?.mute !== undefined && callControlsList?.mute !== null
        ? callControlsList?.mute
        : true,
    hold:
      callControlsList?.hold !== undefined && callControlsList?.hold !== null
        ? callControlsList?.hold
        : true,
    endcall:
      callControlsList?.endcall !== undefined &&
        callControlsList?.endcall !== null
        ? callControlsList?.endcall
        : true,
    answer:
      callControlsList?.answer !== undefined &&
        callControlsList?.answer !== null
        ? callControlsList?.answer
        : true,
    decline:
      callControlsList?.decline !== undefined &&
        callControlsList?.decline !== null
        ? callControlsList?.decline
        : true,
    transfer_agent_warm:
      callControlsList?.transfer_agent_warm !== undefined &&
        callControlsList?.transfer_agent_warm !== null
        ? callControlsList?.transfer_agent_warm
        : true,
    transfer_agent_blind:
      callControlsList?.transfer_agent_blind !== undefined &&
        callControlsList?.transfer_agent_blind !== null
        ? callControlsList?.transfer_agent_blind
        : true,
    transfer_skill_warm:
      callControlsList?.transfer_skill_warm !== undefined &&
        callControlsList?.transfer_skill_warm !== null
        ? callControlsList?.transfer_skill_warm
        : true,
    transfer_skill_blind:
      callControlsList?.transfer_skill_blind !== undefined &&
        callControlsList?.transfer_skill_blind !== null
        ? callControlsList?.transfer_skill_blind
        : true,
    transfer_phone_warm:
      callControlsList?.transfer_phone_warm !== undefined &&
        callControlsList?.transfer_phone_warm !== null
        ? callControlsList?.transfer_phone_warm
        : true,
    transfer_phone_blind:
      callControlsList?.transfer_phone_blind !== undefined &&
        callControlsList?.transfer_phone_blind !== null
        ? callControlsList?.transfer_phone_blind
        : true,
    transfer_ivr_warm:
      callControlsList?.transfer_ivr_warm !== undefined &&
        callControlsList?.transfer_ivr_warm !== null
        ? callControlsList?.transfer_ivr_warm
        : true,
    transfer_ivr_blind:
      callControlsList?.transfer_ivr_blind !== undefined &&
        callControlsList?.transfer_ivr_blind !== null
        ? callControlsList?.transfer_ivr_blind
        : true,
    conference_agent:
      callControlsList?.conference_agent !== undefined &&
        callControlsList?.conference_agent !== null
        ? callControlsList?.conference_agent
        : true,
    conference_phone:
      callControlsList?.conference_phone !== undefined &&
        callControlsList?.conference_phone !== null
        ? callControlsList?.conference_phone
        : true,
    callrecording:
      callControlsList?.callrecording !== undefined &&
        callControlsList?.callrecording !== null
        ? callControlsList?.callrecording
        : true,
    manualdial:
      callControlsList?.manualdial !== undefined &&
        callControlsList?.manualdial !== null
        ? callControlsList?.manualdial
        : true,
    dail_pad:
      callControlsList?.dail_pad !== undefined &&
        callControlsList?.dail_pad !== null
        ? callControlsList?.dail_pad
        : true,
    disposition:
      callControlsList?.disposition !== undefined &&
        callControlsList?.disposition !== null
        ? callControlsList?.disposition
        : true,
    not_enforce_screen_record:
      callControlsList?.not_enforce_screen_record !== undefined &&
        callControlsList?.not_enforce_screen_record !== null
        ? callControlsList?.not_enforce_screen_record
        : true,
    screen_recording_option:
      callControlsList?.screen_recording_option !== undefined &&
        callControlsList?.screen_recording_option !== null
        ? callControlsList?.screen_recording_option
        : null,
  };

  return callControlsJsonList;
}
export function containsChatBotHistory(message) {
  let value = false;
  try {
    const parsedMessage = JSON.parse(message);
    if (parsedMessage.hasOwnProperty("CHAT_BOT_HISTORY")) {
      value = true;
    } else {
      value = false;
    }
  } catch (e) {
    value = false; // If it's not a JSON string, just return false
  }
  return value;
}
export function convertToJsonObject(inputString) {
  try {
    const jsonObject = JSON.parse(inputString);
    let jsonArray = [];
    if (jsonObject.CHAT_BOT_HISTORY) {
      jsonObject.CHAT_BOT_HISTORY = JSON.parse(jsonObject.CHAT_BOT_HISTORY);
      jsonArray = jsonObject.CHAT_BOT_HISTORY;
    }
    return jsonArray;
  } catch (error) {
    console.error("Error parsing JSON:", error);
    return null;
  }
}
export async function screenRecordingWithApi({ action, clientId, agentId, userName, agentName, uploadUrl, recordingMode, ucid, format, quality, intervalMs }) {
  const SCREEN_RECORD_URL = getParam("SCREEN_RECORD_URL");
  console.log("screen->Recording :: Screen Recording with API", action, clientId, agentId, ucid);

  try {
    const response = await fetch(`${SCREEN_RECORD_URL}/api/recording`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        action,
        clientId,
        agentId,
        userName,
        agentName,
        uploadUrl,
        recordingMode,
        ucid,
        format,
        quality,
        intervalMs,
        callerId:ucid,
        options: {
          time: intervalMs,
          quality: quality
        },
      })
    });
    const data = await response.json();
    console.log("screen->Recording :: Screen Recording with API--->", data);
    console.log("action --->", action === 'start');
    console.log("data?.success--->", data?.success)
    if (action === 'start' && data?.success) {
      store.dispatch(setScreenRecordingByApp(true));
    } else if (action === 'stop' && data?.success) {
      store.dispatch(setScreenRecordingByApp(false));
    }
  } catch (e) {
    console.error(e);
  }
}
// export async function setScreenRecordingClientId(clientId) {
//   const SCREEN_RECORD_URL = getParam("SCREEN_RECORD_URL");

//   try {
//     const response = await fetch(`${SCREEN_RECORD_URL}/api/update-client`, {
//       method: 'POST',
//       headers: {
//         'Content-Type': 'application/json'
//       },
//       body: JSON.stringify({
//         clientId,
//       })
//     });
//     const data = await response.json();
//     console.log("screen->Recording :: Screen Recording with API", data);
//   } catch (e) {
//     console.error(e);
//   }
// }